import brands from "./brands.json";
import formsMeta from "./formsMeta.json";

function normalizeHostLike(s) {
  if (!s) return "";
  return s.trim().toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "")
    .replace(/\.$/, "")
    .replace(/:\d+$/, ""); // strip :3000, :5173, etc.
}

function buildDomainMap() {
  const map = {};
  Object.entries(brands).forEach(([name, cfg]) => {
    const raw = (cfg?.homePage || "");
    const d = normalizeHostLike(raw);
    if (!d || !/[a-z]/.test(d)) return;
    map[d] = name;
    map[`www.${d}`] = name;
    const base = d.split(".")[0];
    if (base) map[`${base}.local`] = name;
  });
  return map;
}

const DOMAIN_MAP = buildDomainMap();

export function getCurrentHost() {
  if (typeof window === "undefined") return "";
  return normalizeHostLike(window.location.host || "");
}

export function resolveBrandByHost(host = getCurrentHost()) {
  if (!host) return null;
  if (DOMAIN_MAP[host]) return DOMAIN_MAP[host];
  for (const d of Object.keys(DOMAIN_MAP)) {
    if (host === d || host.endsWith(`.${d}`)) return DOMAIN_MAP[d];
  }
  return null;
}

export function getBrand() {
  const byHost = resolveBrandByHost();
  if (byHost) return byHost;
  const keys = Object.keys(brands);
  const firstReal = keys.find(k => k.toLowerCase() !== "demo");
  return firstReal || "Demo";
}

export function getBrandConfig(brand = getBrand()) {
  return brands[brand] || {};
}

export function getHomePageUrl(brand = getBrand()) {
  const cfg = getBrandConfig(brand);
  const d = normalizeHostLike(cfg.homePage || "");
  return d ? `https://${d}` : "/";
}

export function getLogoPath(brand = getBrand()) {
  const cfg = getBrandConfig(brand);
  return `/images/${cfg.logo || "logo_demo.png"}`;
}

export function applyBrandTheme(brand = getBrand()) {
  const cfg = getBrandConfig(brand);
  const root = document.documentElement;
  if (cfg.primaryColor)   root.style.setProperty("--primary-color", cfg.primaryColor);
  if (cfg.secondaryColor) root.style.setProperty("--secondary-color", cfg.secondaryColor);
  const banner = cfg.banner_logo ? `url("/images/${cfg.banner_logo}")` : "none";
  root.style.setProperty("--banner-logo", banner);
}

export function getArabicName(brand = getBrand()) {
  return (getBrandConfig(brand).arabic_name) || brand;
}
export function getFormMeta(formName, brand = getBrand()) {
  const cfg = getBrandConfig(brand);
  const brandName = cfg.arabic_name || brand;

  const meta = formsMeta[formName];

  if (!meta) {
    return {
      title: "",
      description: ""
    };
  }

  return {
    title: meta.title.replace(/{brand}/g, brandName),
    description: meta.description.replace(/{brand}/g, brandName)
  };
}
export function getSubdomain(host = getCurrentHost()) {
  if (!host) return "";

  const parts = host.split(".");

  if (parts.length < 3) return "";

  return parts[0];
}

export function isBranchesSubdomain(host = getCurrentHost()) {
  return getSubdomain(host) === "branches";
}
export { brands };
